import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BulkDeactivateWorkersMutationCgResponse,
  BulkDeactivateWorkersMutationVariables,
  BulkUpdateWorkersWorkforceGroupMutationCgResponse,
  BulkUpdateWorkersWorkforceGroupMutationVariables,
} from '@common/graphql/schema';

export const BULK_DEACTIVATE_WORKERS_MUTATION: TypedDocumentNode<
  BulkDeactivateWorkersMutationCgResponse,
  BulkDeactivateWorkersMutationVariables
> = gql`
  mutation BulkDeactivateWorkers($workerIds: [ID!]!) {
    bulkDeactivateWorkers(workerIds: $workerIds) {
      workers {
        id
        active
        worksUser {
          id
          firstName
          lastName
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const BULK_UPDATE_WORKERS_WORKFORCE_GROUP_MUTATION: TypedDocumentNode<
  BulkUpdateWorkersWorkforceGroupMutationCgResponse,
  BulkUpdateWorkersWorkforceGroupMutationVariables
> = gql`
  mutation BulkUpdateWorkersWorkforceGroup(
    $workerIds: [ID!]!
    $workforceGroupId: ID!
  ) {
    bulkUpdateWorkersWorkforceGroup(
      workerIds: $workerIds
      workforceGroupId: $workforceGroupId
    ) {
      workers {
        id
        active
        workforceGroup {
          id
          name
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
